export class SsoVerifyGetResponse {
  redirectTo?: string
}
